// extracted by mini-css-extract-plugin
export default {"ProfileImages":"LawyerActiveClients_ProfileImages__x-YTO"};